<template>
    <!-- 子项 -->
    <flow-container :children="tpl.children"></flow-container>
</template>
<script>
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');
export default {
    name: 'basic-swiper/swiper-slide-render',
    components: {
        FlowContainer: ComplexComp.Container.Flow
    },
    props: {
        tpl: {
            type: Object,
            default: () => ({})
        }
    }
};
</script>
<style lang="less">
.basic-swiper-main {
    height: auto !important;
}
</style>
